import { AxiosResponse } from "axios";
import { downloadFileWithUrl } from "./downloadFileWithUrl/downloadFileWithUrl";

export type BlobResponse = Blob;

const downloadFile = (response: AxiosResponse<BlobResponse>) => {
  const header = response.headers["content-disposition"] as string;
  const fileName = header.split("filename=")[1].split(".")[0];
  const extension = header.split(".")[1].split(";")[0];

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const downloadFileName = `${fileName}.${extension}`;

  downloadFileWithUrl(url, downloadFileName);
};

export default downloadFile;
